import React from 'react';
import '../userController/TransactionCreateDialog.css'; 

const TransactionCreateDialog = ({ onClose, onPreview, onBack, title, message, closeText }) => {
    return (
        <div className="dialog-overlay">
      <div className="dialog success-dialog">
        <div className="dialog-header">
          <h3>{title}</h3>
        </div>
        <div className="dialog-body">
          <div className="tick-container">
            <img 
              src="https://i.gifer.com/7efs.gif"
              alt="Success" 
              className="tick-gif" 
            />
          </div>
          <p>{message}</p>
        </div>
        <div className="dialog-footer" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
          <button onClick={() => onBack()}>Back</button>
          {/* <button onClick={() => onClose()}>{closeText}</button> */}
          <button onClick={() => onPreview()}>Preview</button>
        </div>
      </div>
    </div>
    );
};

export default TransactionCreateDialog;